import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';

import App from './App';
import { AuthProvider } from './lib/auth/AuthProvider';
import { CurrencyProvider } from './lib/currency';
import { queryClient } from './lib/queryClient';
import { BASE_URL, ROUTER_BASENAME } from './lib/base';
import './styles/index.css';

// Base-path aware: el router usa basename derivado del base del build
// (import.meta.env.BASE_URL sin barra final). Por defecto "/tembiapo"; con
// build a la raíz queda "" (coincide con el prefijo de la API y el scope del SW).
const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('No se encontró el elemento #root');
}

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter basename={ROUTER_BASENAME}>
        <AuthProvider>
          <CurrencyProvider>
            <App />
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </QueryClientProvider>
  </React.StrictMode>,
);

// Service Worker (PWA + Web Push). Base-path aware: archivo y scope bajo el
// base del build (BASE_URL). Solo en producción y sobre contexto seguro (https o
// localhost), que es lo que exige el navegador para SW y Push.
if (
  'serviceWorker' in navigator &&
  import.meta.env.PROD &&
  window.isSecureContext
) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register(`${BASE_URL}sw.js`, { scope: BASE_URL })
      .catch((err) => {
        console.warn('No se pudo registrar el Service Worker:', err);
      });
  });
}
